var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Button',{attrs:{"to":{
    name: 'projects'
  },"variant":"dark","icon":"projects","radius":""}},[_vm._v("\n  サイト一覧\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }